import React, {useState} from 'react';
import PropTypes from 'prop-types';

import MenuList from './MenuList';

import withIntl from '../../../lib/withIntl';

function Normalization({intl, selected, disabled, onClick, tooltipMessage}) {
  const [hovered, setHovered] = useState(false);
  const getStyle = () => {
    if (disabled) {
      return {
        border: '1px solid #E0E0E0',
        backgroundColor: '#E0E0E0',
        color: '#999999',
      };
    }

    if (selected) {
      return {
        border: '1px solid #37C871',
        backgroundColor: 'white',
        color: '#37C871',
      };
    }

    if (hovered) {
      return {
        border: '1px solid #008F40',
        backgroundColor: '#008F40',
        color: 'white',
      };
    }

    return {
      border: '1px solid #37C871',
      backgroundColor: '#37C871',
      color: 'white',
    };
  };

  return (
    <MenuList.Item
      name={
        <div style={{color: getStyle().color}}>
          <div>{intl.formatMessage({id: 'protocolEditor.menuList.addNormalization'})}</div>
        </div>
      }
      // eslint-disable-next-line
      imgPath={`./svg/protocol-editor/add-normalization${selected ? '-selected' : disabled ? '-disabled' : ''}.svg`}
      onClick={() => {
        if (disabled || selected) {
          return;
        }

        onClick();
      }}
      disabled={disabled}
      style={getStyle()}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      tooltipMessage={tooltipMessage}
    />
  );
}

Normalization.propTypes = {
  intl: PropTypes.any.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tooltipMessage: PropTypes.string,
};

Normalization.defaultProps = {
  selected: false,
  disabled: false,
  onClick: () => {},
  tooltipMessage: '',
};

export default React.memo(
  withIntl(Normalization),
  (prevProps, nextProps) => prevProps.selected === nextProps.selected && prevProps.disabled === nextProps.disabled,
);
